import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/logo.webp';

export default function Logo() {
  return (
    <Link to="/">
      <img src={logo} alt="logo" />
    </Link>
  );
}
